import { render, staticRenderFns } from "./typefilter.vue?vue&type=template&id=384fea62"
import script from "./typefilter.vue?vue&type=script&lang=js"
export * from "./typefilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports